/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { InvoiceCreate } from '../models/InvoiceCreate';
import type { InvoiceResponse } from '../models/InvoiceResponse';
import type { InvoiceUpdate } from '../models/InvoiceUpdate';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class InvoicesService {
    /**
     * Create Invoice
     * @param requestBody
     * @returns InvoiceResponse Successful Response
     * @throws ApiError
     */
    public static createInvoiceInvoicesPost(
        requestBody: InvoiceCreate,
    ): CancelablePromise<InvoiceResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/invoices/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Approve Invoice Endpoint
     * @param invoiceId
     * @returns InvoiceResponse Successful Response
     * @throws ApiError
     */
    public static approveInvoiceEndpointInvoicesInvoiceIdApprovePost(
        invoiceId: number,
    ): CancelablePromise<InvoiceResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/invoices/{invoice_id}/approve',
            path: {
                'invoice_id': invoiceId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get My Invoice
     * @param orderId
     * @returns InvoiceResponse Successful Response
     * @throws ApiError
     */
    public static getMyInvoiceInvoicesOrdersOrderIdInvoiceGet(
        orderId: number,
    ): CancelablePromise<InvoiceResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/invoices/orders/{order_id}/invoice',
            path: {
                'order_id': orderId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Admin List Invoices
     * @returns InvoiceResponse Successful Response
     * @throws ApiError
     */
    public static adminListInvoicesInvoicesAdminInvoicesGet(): CancelablePromise<Array<InvoiceResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/invoices/admin/invoices',
        });
    }
    /**
     * Admin Get Invoice
     * @param invoiceId
     * @returns InvoiceResponse Successful Response
     * @throws ApiError
     */
    public static adminGetInvoiceInvoicesAdminInvoiceIdGet(
        invoiceId: number,
    ): CancelablePromise<InvoiceResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/invoices/admin/{invoice_id}',
            path: {
                'invoice_id': invoiceId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Admin Update Invoice
     * @param invoiceId
     * @param requestBody
     * @returns InvoiceResponse Successful Response
     * @throws ApiError
     */
    public static adminUpdateInvoiceInvoicesInvoiceIdPatch(
        invoiceId: number,
        requestBody: InvoiceUpdate,
    ): CancelablePromise<InvoiceResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/invoices/{invoice_id}',
            path: {
                'invoice_id': invoiceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Admin Delete Invoice
     * @param invoiceId
     * @returns void
     * @throws ApiError
     */
    public static adminDeleteInvoiceInvoicesInvoiceIdDelete(
        invoiceId: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/invoices/{invoice_id}',
            path: {
                'invoice_id': invoiceId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
